var __vue_script__, __vue_template__
require("!!./../node_modules/extract-text-webpack-plugin/loader.js?{\"remove\":true}!css!./../node_modules/vue-loader/lib/style-rewriter.js!stylus!./../node_modules/vue-loader/lib/selector.js?type=style&index=0!./UiPreloader.vue")
__vue_script__ = require("!!babel-loader!./../node_modules/vue-loader/lib/selector.js?type=script&index=0!./UiPreloader.vue")
if (__vue_script__ &&
    __vue_script__.__esModule &&
    Object.keys(__vue_script__).length > 1) {
  console.warn("[vue-loader] src\\UiPreloader.vue: named exports in *.vue files are ignored.")}
__vue_template__ = require("!!vue-html-loader!./../node_modules/vue-loader/lib/selector.js?type=template&index=0!./UiPreloader.vue")
module.exports = __vue_script__ || {}
if (module.exports.__esModule) module.exports = module.exports.default
if (__vue_template__) {
(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
}
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  var id = "C:\\code\\packages\\keen-ui\\src\\UiPreloader.vue"
  if (!module.hot.data) {
    hotAPI.createRecord(id, module.exports)
  } else {
    hotAPI.update(id, module.exports, __vue_template__)
  }
})()}


/*****************
 ** WEBPACK FOOTER
 ** ./src/UiPreloader.vue
 ** module id = 113
 ** module chunks = 0
 **/